document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.selo-adipec').forEach(function (root) {
    var triggers = root.querySelectorAll('.selo-adipec__gallery-trigger');
    var lightbox = root.querySelector('.selo-adipec__lightbox');

    if (!triggers.length || !lightbox) return;

    var img = lightbox.querySelector('.selo-adipec__lightbox-img');
    var closeBtn = lightbox.querySelector('.selo-adipec__lightbox-close');
    var prevBtn = lightbox.querySelector('.selo-adipec__lightbox-prev');
    var nextBtn = lightbox.querySelector('.selo-adipec__lightbox-next');
    var backdrop = lightbox.querySelector('.selo-adipec__lightbox-backdrop');

    var images = Array.prototype.map.call(triggers, function (trigger) {
      return {
        src: trigger.getAttribute('data-full'),
        alt: trigger.getAttribute('data-alt') || ''
      };
    });

    var current = 0;

    function render() {
      img.src = images[current].src;
      img.alt = images[current].alt;
    }

    function open(index) {
      current = index;
      render();
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    function show(index) {
      current = (index + images.length) % images.length;
      render();
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        open(index);
      });
    });

    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    prevBtn.addEventListener('click', function () {
      show(current - 1);
    });
    nextBtn.addEventListener('click', function () {
      show(current + 1);
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
  });
});
